import type { Board } from "../board";
import type { Direction } from "../direction";
import { directionDelta } from "../direction";
import type { Player } from "../player";
import { CannonBullet } from "../projectiles/cannonBullet";
import { Sound } from "../things/sounds/sound";
import { SoundId } from "../things/sounds/soundId";
import { ParticleType } from "../particleType";
import { Weapon } from "../weapon";
import { WeaponVisual } from "../weaponVisual";

export class Cannon extends Weapon {
	static key = "Cannon";
	constructor(owner: Player) {
		super(owner, 20);
	}

	override getMuzzleFlashType(): ParticleType {
		return ParticleType.MUZZLE_FLASH;
	}

	override getWeaponVisual(): WeaponVisual {
		return WeaponVisual.CANNON;
	}

	fire(direction: Direction, board: Board): void {
		board.addNonPhysicalThing(new Sound(SoundId.SHOT));
		const delta = directionDelta(direction);
		const spawnPos = this.owner.xy.add(delta);
		const bullet = new CannonBullet(spawnPos, direction);
		this.shotProjectile(board, bullet);
	}

	static deserialize(data: any, owner: Player): Cannon {
		const gun = new Cannon(owner);
		gun.ammo = data.ammo;
		return gun;
	}
}
